import type { NodeType } from 'prosemirror-model';
import type { BehaviorSubject } from 'rxjs';

import { ListService } from '../list/list-service-public';

export class ChecklistService extends ListService {
  constructor(
    protected listNodeType: NodeType,
    protected itemNodeType: NodeType,
    protected paragraphNodeType: NodeType,
    private canToggleCheckbox$: BehaviorSubject<boolean>,
  ) {
    super(listNodeType, itemNodeType, paragraphNodeType);
  }

  public setCanEdit(value: boolean) {
    this.canToggleCheckbox$.next(value);
  }
}
